/**
 * Derived UI color tokens based on dark/light state.
 * Avoids re-computing the same conditional color strings in every component.
 */
export interface ThemeColors {
  bgCol: string;
  borderCol: string;
  cardBg: string;
}

export function getThemeColors(isDark: boolean): ThemeColors {
  return {
    bgCol: isDark ? 'bg-[#111111] text-[#FAF8F5]' : 'bg-[#FFFFFF] text-[#111111]',
    borderCol: isDark ? 'border-[#1F242E]' : 'border-[#EAEAEA]',
    cardBg: isDark ? 'bg-[#1C1C1E]' : 'bg-[#F9F9F8]',
  };
}
